import SensorListModelBase from '../_generated/modelBases/sensor-list-model-base';

export default class SensorListModel extends SensorListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
